/*
  ENSEC formulärskydd (DRAFT 2026-10-24)
  A: Kundtyp "Företag" visar Företagsnamn (obligatoriskt) och Organisationsnummer (valfritt).
     Vid "Privat" döljs raden och fälten skickas inte med.
  C: Skydd mot dubbelklick. Knappen låses först när formuläret har klarat webbläsarens
     validering. Högst en riktig sändning per sidvisning. Om inget hann skickas (offline,
     stängd captcha) låses knappen upp igen; efter bakåtknapp återställs den alltid.
  Gäller: #EnsecContactForm (kontakt + TSCM) och #EnsecPbsForm. Ingen design ändras.
*/
(function () {
  'use strict';

  var RECOVER_MS = 15000;        /* validerat men inget skickat (t.ex. stängd captcha) */
  var SENT_FALLBACK_MS = 45000;  /* endast webbläsare utan Navigation API */
  var HAS_NAV_API = !!(window.navigation && typeof window.navigation.addEventListener === 'function');
  var isEn = /^en/i.test(document.documentElement.lang || '') || /(^|\/)en(\/|$)/.test(location.pathname);
  var MSG = isEn ? {
    offline: 'You appear to be offline. Check your connection and try again.',
    notSent: 'Your inquiry was not sent. Please try again.',
    aborted: 'Sending was interrupted and we have no confirmation. You can send your inquiry again.'
  } : {
    offline: 'Du verkar vara offline. Kontrollera anslutningen och försök igen.',
    notSent: 'Förfrågan skickades inte. Försök igen.',
    aborted: 'Sändningen avbröts och vi har ingen bekräftelse. Du kan skicka förfrågan igen.'
  };

  var FORMS = [
    {
      sel: '#EnsecContactForm',
      label: '.ensec-contact__submit-label',
      spinner: '.ensec-contact__submit-spinner',
      errors: '.ensec-contact__errors',
      errorClass: 'ensec-contact__errors'
    },
    {
      sel: '#EnsecPbsForm',
      label: '.ensec-pbs__contact-submit-label',
      spinner: '.ensec-pbs__contact-submit-spinner',
      errors: '.ensec-pbs__form-errors',
      errorClass: 'ensec-pbs__form-errors',
      restoreBody: true
    }
  ];

  /* ---------- A: Företagsfält ---------- */
  function initBusiness(form) {
    var row = form.querySelector('[data-business-only]');
    if (!row || row.getAttribute('data-ensec-biz') === '1') return;
    row.setAttribute('data-ensec-biz', '1');
    var radios = form.querySelectorAll('input[name="contact[Kundtyp]"]');
    var company = row.querySelector('input[name="contact[Företag]"]');
    var inputs = row.querySelectorAll('input');

    function sync() {
      var checked = form.querySelector('input[name="contact[Kundtyp]"]:checked');
      var biz = !!checked && checked.value === 'Företag';
      row.style.display = biz ? 'grid' : 'none';
      for (var i = 0; i < inputs.length; i++) inputs[i].disabled = !biz;
      if (company) {
        company.required = biz;
        company.setAttribute('aria-required', biz ? 'true' : 'false');
      }
    }
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }

  /* ---------- C: Dubbelklicksskydd ----------
     Faser: 'idle' (redo), 'pending' (validerat, väntar på t.ex. Shopifys hCaptcha),
     'sent' (den riktiga sändningen har startat).
     - 'sent' låses bara upp om sändningen bevisligen avbröts (navigateerror) eller,
       i webbläsare utan Navigation API, om sidan ligger kvar SENT_FALLBACK_MS efteråt.
     - 'pending' låses upp efter RECOVER_MS (inget har skickats, t.ex. stängd captcha).
     - Bakåtknapp (pageshow) återställer alltid. */
  function initGuard(form, cfg) {
    if (form.getAttribute('data-ensec-guard') === '1') return;
    form.setAttribute('data-ensec-guard', '1');
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var label = btn.querySelector(cfg.label);
    var spinner = btn.querySelector(cfg.spinner);
    var body = form.querySelector('[name="contact[body]"]');
    var state = { phase: 'idle', timer: null, bodyBefore: null };
    var nativeSubmit = HTMLFormElement.prototype.submit;

    function markSent() {
      if (state.phase === 'sent') return;
      state.phase = 'sent';
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
      /* Webbläsare utan Navigation API: om sidan fortfarande är kvar långt efter att
         sändningen startade har den avbrutits (t.ex. Stopp/Esc). Släpp då ett nytt försök. */
      if (!HAS_NAV_API) {
        state.timer = setTimeout(function () {
          state.timer = null;
          if (state.phase !== 'sent') return;
          reset();
          showError(MSG.aborted); errBox().setAttribute('data-ensec-msg', '1');
        }, SENT_FALLBACK_MS);
      }
    }

    /* Shopifys hCaptcha binder formuläret vid fokus och sparar då form.submit som sin
       "riktiga" sändning. Genom att lägga omslaget här först ser vi exakt när den sker,
       och en andra riktig sändning stoppas även om captchan skulle köras två gånger. */
    if (form.getAttribute('data-hcaptcha-bound') !== 'true') {
      try {
        form.submit = function () {
          if (state.phase === 'sent') return;
          markSent();
          return nativeSubmit.call(form);
        };
      } catch (err) {}
    }

    function errBox() {
      var box = form.querySelector(cfg.errors);
      if (!box) {
        box = document.createElement('div');
        box.className = cfg.errorClass;
        box.setAttribute('role', 'alert');
        box.hidden = true;
        form.insertBefore(box, form.firstChild);
      }
      return box;
    }
    function showError(msg) { var b = errBox(); b.textContent = msg; b.hidden = false; }
    function clearError() {
      var b = form.querySelector(cfg.errors);
      if (b && b.getAttribute('data-ensec-msg') === '1') { b.hidden = true; b.textContent = ''; }
    }
    function setBusy(on) {
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (label) label.hidden = on;
      if (spinner) spinner.hidden = !on;
      if (on) { setTimeout(function () { if (state.phase !== 'idle') btn.disabled = true; }, 0); }
      else { btn.disabled = false; }
    }
    function reset() {
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
      if (cfg.restoreBody && body && state.bodyBefore !== null) { body.value = state.bodyBefore; }
      state.bodyBefore = null;
      state.phase = 'idle';
      setBusy(false);
    }

    form._ensecGuard = function (e) {
      /* Redan på väg eller skickat: stoppa dubbletten innan andra lyssnare (hCaptcha, HubSpot) ser den. */
      if (state.phase !== 'idle') { e.preventDefault(); e.stopPropagation(); return; }
      /* Formulär med novalidate (PBS) valideras här; övriga är redan validerade av webbläsaren. */
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        e.preventDefault(); e.stopPropagation();
        if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }
      if (navigator.onLine === false) {
        e.preventDefault(); e.stopPropagation();
        showError(MSG.offline); errBox().setAttribute('data-ensec-msg', '1');
        return;
      }
      clearError();
      if (cfg.restoreBody && body) state.bodyBefore = body.value;
      state.phase = 'pending';
      setBusy(true);
      state.timer = setTimeout(function () {
        state.timer = null;
        /* Bara om inget har skickats (t.ex. captcha stängd eller misslyckad). */
        if (state.phase !== 'pending') return;
        reset();
        showError(MSG.notSent); errBox().setAttribute('data-ensec-msg', '1');
      }, RECOVER_MS);
    };

    /* Sist i kedjan: om ingen annan stoppade händelsen skickar webbläsaren formuläret nu. */
    form._ensecAfter = function (e) {
      if (state.phase === 'pending' && !e.defaultPrevented) markSent();
    };

    /* Reserv om hCaptcha hann binda före oss: sidan lämnas = sändningen har startat. */
    window.addEventListener('beforeunload', function () { if (state.phase === 'pending') markSent(); });

    /* Bakåtknapp efter avbruten eller misslyckad sändning: knappen ska gå att använda igen. */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) reset(); });

    /* Chrome/Edge m.fl.: sändningen avbröts (Stopp/Esc) och sidan ligger kvar. */
    if (HAS_NAV_API) {
      window.navigation.addEventListener('navigateerror', function () {
        if (state.phase !== 'sent') return;
        reset();
        showError(MSG.aborted); errBox().setAttribute('data-ensec-msg', '1');
      });
    }
  }

  /* Capture-fas på window körs före formulärets egna lyssnare (PBS-skript, hCaptcha, HubSpot). */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && typeof f._ensecGuard === 'function') f._ensecGuard(e);
  }, true);
  /* Bubbel-fas på window körs sist av alla. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && typeof f._ensecAfter === 'function') f._ensecAfter(e);
  }, false);

  function init() {
    for (var i = 0; i < FORMS.length; i++) {
      var forms = document.querySelectorAll(FORMS[i].sel);
      for (var j = 0; j < forms.length; j++) {
        initBusiness(forms[j]);
        initGuard(forms[j], FORMS[i]);
      }
    }
  }
  /* Laddas direkt efter formulären (utan defer) så att skyddet är aktivt innan besökaren
     hinner fokusera ett fält och Shopifys hCaptcha binder. init() är idempotent. */
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
})();
